import TabPage from "./../../factories/tab-page";
import "./../../factories/bao-dialog";
import "./../bindings/ace-binding";
import "./event-script.css";
import BaseViewModel from "./../../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class EventScript extends BaseViewModel {
    constructor(tabPage: TabPage) {
        super(tabPage);
    }
    ChecklistTab: TabPage;
    checklistTabTitle = ko.observable("");
    Name = ko.observable<string>();
    Version = ko.observable<string>();
    Script = ko.observable<string>();
    EditorBinding: Bindings.ace = {
        init: (obj: AceBindingInit) => {
            obj.Editor.setTheme("ace/theme/chrome");
        },
        value: this.Script
    };
    CompleteCheck() {
        var isComplete: boolean = true;
        if (this.Name() == null || this.Script() == null || this.Name() == "" || this.Script() == "") {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    InitUrl() {
        return "Checkware/EventScript/Init";
    }
    init() {
        var def = $.Deferred<void>();
        super.init().then(() => {
            super.InitTabController().then(() => {
                this.ChecklistTab = new TabPage();
                this.ChecklistTab.IsClosable(false);
                this.ChecklistTab.Url("Checkware/EventScriptChecklistTab");
                this.TabController.AddTab(this.ChecklistTab);
                def.resolve();
            });
        });
        return def.promise();
    }
}
export default EventScript;